import type { SubscriptionPreview } from "@/API";
import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient } from "aws-amplify/api";
import { previewSubscriptionPrice } from "@/graphql/mutations";

const client = generateClient();

export const previewUpdatePriceState = create<State<SubscriptionPreview>>(
  () => ({
    data: null,
    isLoading: false,
    error: null,
    isFetching: false,
  }),
);

export const getPreviewUpdatePriceIsloading = () =>
  previewUpdatePriceState.setState(() => ({
    isLoading: true,
    isFetching: false,
    data: null,
    error: null,
  }));
export const getPreviewUpdatePriceIsError = (error: Error) =>
  previewUpdatePriceState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
    isFetching: false,
  }));
export const getPreviewUpdatePriceIsSuccess = (
  queryResult: SubscriptionPreview,
) =>
  previewUpdatePriceState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
    isFetching: false,
  }));

type GetPreviewUpdatePriceParams = {
  priceId: string;
  quantity?: number;
};

export const getPreviewUpdatePrice = async (
  params: GetPreviewUpdatePriceParams,
) => {
  getPreviewUpdatePriceIsloading();

  try {
    const { data } = await client.graphql({
      query: previewSubscriptionPrice,
      variables: {
        priceId: params.priceId,
        quantity: params.quantity || 1,
      },
    });

    getPreviewUpdatePriceIsSuccess(
      data.previewSubscriptionPrice as SubscriptionPreview,
    );
  } catch (e) {
    const errorMessage =
      e instanceof Error
        ? e.message
        : "failed to mutate previewSubscriptionPrice";
    getPreviewUpdatePriceIsError(Error(errorMessage));
  }
};
